module.exports = __webpack_public_path__ + "img/martin-wolfaardt.5c494385.png";